import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export type ListSelectionOptions = 'selectAll' | 'selectNone' | 'undefined';

export interface ListSelectionItem {
    label: string;
    isSelected?: boolean;
    isBold?: boolean;
    isDisabled?: boolean;
    data?: any;
}
/**
 * Component that shows a list of elements and allows (de)selecting them
 *
 * How to use it:
 * A list of ListSelectionItem must be passed
 *
 * @example
 * <cw-list-selection [items]="items" (elementsSelect)="onSelected()">
 * </cw-list-selection>
 */
@Component({
    selector: 'cw-list-selection',
    templateUrl: 'list-selection.component.html',
    styleUrls: ['./list-selection.component.scss'],
    standalone: false,
})
export class ListSelectionComponent implements OnInit {
    /** Text for all selection label */
    @Input() allSelectionLabel = '';

    /** List of items to fill the component */
    @Input() set items(value: ListSelectionItem[]) {
        this._items = value;
        this.updateSelectAllCheckbox();
    }
    get items(): ListSelectionItem[] {
        return this._items;
    }

    _items!: ListSelectionItem[];

    /** Emits all data when a change in the current selection is done */
    @Output() elementsSelect = new EventEmitter<ListSelectionItem[]>();

    selectionState: ListSelectionOptions = 'selectNone';

    ngOnInit(): void {
        this.updateSelectAllCheckbox();
    }

    onSelectStateAllClicked(e: Event): void {
        const value = (e.target as any).checked;
        this.items.forEach((item: ListSelectionItem) => {
            if (!item.isDisabled) {
                item.isSelected = value;
            }
        });

        this.elementsSelectEmit(this.items);
    }

    onSelectElement(item: ListSelectionItem): void {
        item.isSelected = !item.isSelected;
        this.updateSelectAllCheckbox();

        this.elementsSelectEmit(this.items);
    }

    private updateSelectAllCheckbox(): void {
        if (!this.items) {
            this.selectionState = 'selectNone';
            return;
        }

        const selectedItems = this.items.filter((item: ListSelectionItem) => item.isSelected);
        const itemsDisabled = this.items.filter((item: ListSelectionItem) => item.isDisabled);
        switch (selectedItems.length) {
            case 0:
                this.selectionState = 'selectNone';
                break;
            case this.items.length - itemsDisabled.length:
                this.selectionState = 'selectAll';
                break;
            default:
                this.selectionState = 'undefined';
        }
    }

    private elementsSelectEmit(item: any): void {
        this.elementsSelect.emit(item);
    }
}
